import { Component, OnDestroy, Input }  from '@angular/core';
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { AppState } from "../../../reducers";
import { AdditionalChargeActions } from "../../../actions";

import { AdditionalCharge } from '../../../models/additional-charge.model';
import { AdditionalChargesToSave } from '../../../actions';

@Component({
	selector: 'additional-charges',
	template: `
		<h1>Veranstaltung einrichten - Zusätzliche Leistungen</h1>
		<div>
			<additional-charges-presentation
				[additionalCharges]="additionalCharges"
				(deleteAdditionalCharge)="deleteAdditionalCharge($event)"
				(save)="save($event)"
			></additional-charges-presentation>
		</div>`
})

export class AdditionalChargesComponent implements OnDestroy {

	private additionalCharges: AdditionalCharge[];
	private collectionUrl: string;
	private additionalChargeSubscription: Subscription;

	constructor(
		private additionalChargeActions: AdditionalChargeActions,
		private store: Store<AppState>
	) {}

	ngOnDestroy() {
		if (this.additionalChargeSubscription) {
			this.additionalChargeSubscription.unsubscribe();
		}
	}

	@Input() set additionalChargeCollectionUrl(url: string) {
		this.collectionUrl = url;
		if (url) {
			this.store.dispatch(this.additionalChargeActions.loadCollection(url));
			this.additionalChargeSubscription = this.store.select("eventServerState", "additionalCharges", "additionalCharges")
				.subscribe(additionalCharges => this.additionalCharges = additionalCharges);
		}
	}

	protected save(additionalChargeData: any[]) {
		const additionalChargeUpdates: AdditionalCharge[] = this.createAdditionalChargeUpdates(additionalChargeData);
		const additionalChargesToSave: AdditionalChargesToSave = {
			additionalChargeCollectionUrl: this.collectionUrl,
			additionalCharges: additionalChargeUpdates
		}
		this.store.dispatch(this.additionalChargeActions.saveAdditionalCharges(additionalChargesToSave));
	}

	protected deleteAdditionalCharge(deleteRef: string) {
		this.store.dispatch(this.additionalChargeActions.deleteAdditionalCharge(deleteRef));
	}

	private createAdditionalChargeUpdates(additionalChargeData: any[]): AdditionalCharge[] {
		let pos: number = this.getPositionNumberAfterLast(this.additionalCharges);
		const additionalChargeUpdates: AdditionalCharge[] = additionalChargeData.map(dataElement => {
			if (dataElement.value['self']) {
				return this.createAdditionalChargeUpdateCopy(dataElement)
			}
			const newAdditionalCharge: AdditionalCharge =  this.createNewAdditionalCharge(dataElement, pos);
			pos++;
			return newAdditionalCharge;
		});
		return additionalChargeUpdates;
	}

	private createAdditionalChargeUpdateCopy(dataElement): AdditionalCharge {
		const additionalCharge: AdditionalCharge = this.additionalCharges.find(currentAdditionalCharge =>
			currentAdditionalCharge._links.self.href === dataElement.value['self']
		);
		let additionalChargeCopy: AdditionalCharge = Object.assign({}, additionalCharge);
		const filledCopy = this.populateAdditionalCharge(additionalChargeCopy, dataElement);
		return filledCopy;
	}

	private createNewAdditionalCharge(dataElement: any, pos: number) {
		const additionalCharge: AdditionalCharge = new AdditionalCharge();
		let filledAdditionalCharge: AdditionalCharge = this.populateAdditionalCharge(additionalCharge, dataElement);
		filledAdditionalCharge.pos = pos;
		return filledAdditionalCharge;
	}

	private getPositionNumberAfterLast(additionalCharges: AdditionalCharge[]) {
		if (additionalCharges.length < 1) { return 0; }
		const positions: number[] = additionalCharges.map(additionalCharge => additionalCharge.pos)
		const positionAfterLast: number = Math.max(...positions) + 1;
		return positionAfterLast;
	}

	private populateAdditionalCharge(additionalCharge: AdditionalCharge, dataElement: any) {
		additionalCharge.description = dataElement.value['description'];
		additionalCharge.price.money.value = this.parseNumber(dataElement.value['price']);
		additionalCharge.price.vat = this.parseNumber(dataElement.value['vat']);
		return additionalCharge;
	}

	private parseNumber(str: string) {
		let numberStr = str;
		if (!str) {
			return 0
		}
		if (str && str.replace)
			numberStr = str.replace("," , ".");
		return parseFloat(numberStr)
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/additional-charges/additional-charges.component.ts